/**
 * Copyright 2022 Design Barn Inc.
 */

import { LottiePlugin } from '@lottiefiles/toolkit-plugin-lottie';

export const lottiePlugin = new LottiePlugin();
